import { useState } from "react";
import { createModel } from "hox";
import { ISCMHistoryModal } from "./purchasePoTypes"
/**
 * 商品明细弹框
 */
export const useRecordGoodsModel = createModel(function () {


    const [goodsRecordModal, setGoodsRecordModal] = useState<ISCMHistoryModal>({
        visible: false,
        materialCode: "",
        inventoryQuantity: 0,
        code: '',
        orderType: ''
    });

    return {
        goodsRecordModal, setGoodsRecordModal
    }
});